/**
 * 数据持久化
 */
import store from '@/store'
import LocalStorage from '@/utils/localStorage'

export default function Initializer () {
  store.commit('SET_USER_INFO', LocalStorage.get('user') ? JSON.parse(LocalStorage.get('user')) : {})
  store.commit('SET_TOKEN', LocalStorage.get('token'))
  store.commit('SET_TABS_LIST', LocalStorage.get('tabs_list') ? JSON.parse(LocalStorage.get('tabs_list')) : [])
}
